import { call, put, takeLatest } from 'redux-saga/effects';
import { 
  FETCH_ONBOARDING_DATA_REQUEST, 
  ON_BOARDING_IMAGES_REQUEST, 
  SAVE_ONBOARDING_DATA_REQUEST,
  UNPUBLISH_ONBOARDING_REQUEST 
} from '../actions/actionTypes';
import {
  setRequestError,
  setRequestLoading,
  setRequestSuccess,
} from '../actions/common/common.actions';
import { onBoardingKeys } from '@src/CommonComponents/constant/constant';
import { getOnboardingData ,getOnboardingImages,saveOnboardingData, unpublishOnboarding } from '../services/onBoarding/onBoarding.service';



const getOnBoardingMethod: any = (key: string) => {
  switch (key) {
    case onBoardingKeys.list:
      return getOnboardingData;
      
    case onBoardingKeys.save:
      return saveOnboardingData;
      
    case onBoardingKeys.images:
      return getOnboardingImages;

    case 'unpublish':
      return unpublishOnboarding;

    default:
      return getOnboardingData;
  }
};
export function* fetchOnBoardingData(action: any) {
  const { key, payload } = action;
  const loadingKey = `${key}Loading`;
  const errorKey = `${key}Error`;

  try {
    yield put(setRequestError(false, errorKey));
    yield put(setRequestLoading(true, loadingKey));

    
    const response = yield call(getOnBoardingMethod(key), payload);

    yield put(setRequestLoading(false, loadingKey));

    if (response?.status === false) {
      yield put(setRequestError(true, errorKey));
    } else {
      yield put(setRequestSuccess(response?.Data, key));
    }
  } catch (error) {
    yield put(setRequestLoading(false, loadingKey));
    yield put(setRequestError(true, errorKey));
  }
}
export function* onBoardingSaga() {
  // Make sure FETCH_ONBOARDING_DATA_REQUEST and SAVE_ONBOARDING_DATA_REQUEST are string constants
  yield takeLatest(FETCH_ONBOARDING_DATA_REQUEST, fetchOnBoardingData);
  yield takeLatest(SAVE_ONBOARDING_DATA_REQUEST, fetchOnBoardingData);
  yield takeLatest(ON_BOARDING_IMAGES_REQUEST, fetchOnBoardingData);
  yield takeLatest(UNPUBLISH_ONBOARDING_REQUEST, fetchOnBoardingData);
}

export default [onBoardingSaga];
